import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { GROUP_USERS_STATUS, GROUP_USERS_STATUS_LABEL } from 'constants/groups';

import { useGroupsContext } from '../GroupsContext';

const GroupsFiltersUsers = () => {
  const { filters, setFilters } = useGroupsContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, has_users: values });
  };

  const options = [
    {
      label: GROUP_USERS_STATUS_LABEL[GROUP_USERS_STATUS.WITH_USERS],
      value: GROUP_USERS_STATUS.WITH_USERS,
    },
    {
      label: GROUP_USERS_STATUS_LABEL[GROUP_USERS_STATUS.WITHOUT_USERS],
      value: GROUP_USERS_STATUS.WITHOUT_USERS,
    },
  ];

  return (
    <SelectAdvancedFilter
      className={classNames({ active: Boolean(filters.has_users?.length) })}
      placeholder={'Users'}
      options={options}
      defaultValue={filters?.has_users ?? []}
      onSelect={handleSelect}
    />
  );
};

export default GroupsFiltersUsers;
